import * as S from './style';

const Line = () => {
  return <S.Wrapper />;
};

export default Line;
